<template>
  <div>
    <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{titleModal}}</div>
    <div style="word-break: break-all; white-space: pre-wrap;">{{type}}</div> -->
    <component
      v-model="titleModal"
      :is="componentName"
      :info="info.config"
      :commmonType="type"
      :index="index"
      @close="close"
      @add="add"
    ></component>
  </div>
</template>

<script>
import customTitleType1 from "@components/custom-component/common/custom-title/components/custom-title-type-1.vue";
export default {
  // 标题类型 1
  name: "custom-title",
  model: {
    prop: "titleModal",
    event: "sendTitleModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    titleModal: {
      type: Object,
      default: function() {
        return {
          type: 1, // 标题类型 暂时只有 1
          content: "文本内容",
          position: "left", // 文本对齐格式
          padding: "3px", // 标题的边距
          fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
          color: "#000", // 文字颜色 默认黑色
          link: {
            type: 0,
            value: ""
          }
        };
      }
    },
    info: {
      type: Object,
      default: {
        title: "标题",
        icon: "icon-biaoti",
        type: "title",
        componentName: "customTitle",
        config: {
          type: 1, // 标题类型 暂时只有 1
          content: "",
          position: "left", // 文本对齐格式
          padding: "3px", // 标题的边距
          fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
          color: "#000", // 文字颜色
          link: {
            type: "0",
            value: ""
          }
        }
      }
    },
    type: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1
    }
  },
  computed: {
    componentName() {
      return `customTitleType${this.info.config.type}`;
    }
  },
  data() {
    return {};
  },
  components: {
    customTitleType1
  },
  methods: {
    close() {
      this.$emit("close");
    },
    add(item, idx) {
      this.$emit("add", item, idx);
    }
  }
};
</script>

<style scoped lang="scss">
</style>
